import React, { useState } from 'react';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
import './customTourStyles.css'; // You'll define custom styles here

const CampNoDataTooltip = ({ showTooltip, setShowTooltip, step }) => {
  return (
    <Steps
      enabled={showTooltip}
      steps={step}
      initialStep={0}
      onExit={() => setShowTooltip(false)} // Handle exit to disable tour
      options={{
        doneLabel: 'Close',
      }}
    />
  );
};

export default CampNoDataTooltip;
